import { FEATURE_FLAGS } from '../helpers/constants';
import { usePlangridFeatureFlag } from '../PlangridLaunchDarklyProvider';
import useTemplateName from './useTemplateName';

export const useDisplayName = (form) => {
  const { value: enableRenameForms } = usePlangridFeatureFlag(
    FEATURE_FLAGS.RENAME_FORMS,
    false,
  );
  const { templateName } = useTemplateName(form);

  return enableRenameForms ? form.name || templateName : templateName;
};
